import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyCongViecApi from "service/QuanLyCongViec/QuanLyCongViecApi";
import { pushNotification } from "../../../../utils/notifications";

export const ModalXoa = ({ id, show, onHide, onSaved }) => {
    const [isSubmit, setIsSubmit] = useState(false);

    const handleDelete = async () => {
        setIsSubmit(true);
        try {
            const res = await QuanLyCongViecApi.deleteTask(id);
            if (res.status === 200) {
                pushNotification("Xóa thành công!", "success", "TOP_CENTER", 2000);
                onSaved();
            } else {
                pushNotification(res.message || "Xóa thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error(error);
            pushNotification(error.message || "Đã xảy ra lỗi!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" className="modal-new modal fade text-left">
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                     <span className="btn-icon-right"><img src="/app-assets/images/icon-xoa-v2.png" alt="icon" /></span>
                    Xác nhận xóa
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide} disabled={isSubmit}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form-body text-center">
                    <h5>Bạn có chắc chắn muốn xóa công việc này không?</h5>
                    <p>Hành động này không thể hoàn tác.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                 <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide} disabled={isSubmit}>
                    <span><i className="mdi mdi-close"></i></span>&nbsp; Hủy
                </button>
                <button 
                    type="button" 
                    className="btn btn-danger" 
                    onClick={handleDelete} 
                    disabled={isSubmit}
                    style={{ borderRadius: '8px', padding: '10px 20px' }}
                >
                    <span><i className="mdi mdi-delete"></i></span>&nbsp; {isSubmit ? "Đang xóa..." : "Xóa"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};